module.exports = __webpack_public_path__ + "img/stage7.1f5f0615.png";